import Swal from "sweetalert2";
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Eetiquetas = {
  agregarEtiqueta: async (data) => {
    let url = url_json + "/etiqueta-blog";
    let body = {
      nombre: data.nombre,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Etiqueta agregada correctamente",
        "success"
      );
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar la etiqueta, codigo: " + res.message,
        "error"
      );
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtenerEtiquetas: async () => {
    let url = url_json + "/etiqueta-blog";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerEtiquetasIDs: async (ids) => {
    let url = url_json + "/etiqueta-blog/ids";
    let body = {
      ids,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnaEtiqueta: async (id) => {
    let url = url_json + "/etiqueta-blog/" + id;
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUso: async () => {
    let url = url_json + "/etiqueta-blog/uso";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarEtiqueta: async (data, id) => {
    let url = url_json + "/etiqueta-blog/" + id;
    let body = {
      nombre: data.nombre,
    };
    let request = {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Modificación exitosa!",
        "Etiqueta modificada correctamente",
        "success"
      );
    } else {
      Swal.fire("Error!", "No se pudo modificar la etiqueta: " + res.message, "error");
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  eliminarEtiqueta: async (id) => {
    let url = url_json + "/etiqueta-blog/delete/" + id;
    let request = {
      method: "PATCH",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Eliminación exitosa!",
        "Etiqueta eliminada correctamente",
        "success"
      );
    } else {
      Swal.fire("Error!", "No se pudo eliminar la etiqueta: " + res.message, "error");
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
};

export default Eetiquetas;
